const policy = [{
  desc: '用户查询接口',
  options: {
    url: '/customer/getNewCustomerPage',
    method: 'post'
  }
}, {
  desc: '获取商户对应版本（基础版、专业版、企业版）角色数据',
  options: {
    url: '/role/getAllRolesBySystemVersion',
    method: 'post'
  }
}, {
  desc: '用户新增编辑接口',
  options: {
    url: '/customer/saveOrUpdateCustomer',
    method: 'post'
  }
}, {
  desc: '根据车险组织机构id获取人管组织机构id',
  options: {
    url: '/customer/getSysBranchOrgByOrgId',
    method: 'post'
  }
}, {
  desc: '根据机构类型获取角色组分类',
  options: {
    url: '/roleGroup/queryRoleGroupForOrgType',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '身份证号接口',
  options: {
    url: '/customer/checkCustomerUserIdCardNO',
    method: 'post'
  }
}, {
  desc: '用户操作启用禁用/重置密码接口',
  options: {
    url: '/customer/updateCustomerPwdOrSatus',
    method: 'post'
  }
}, {
  desc: '用户信息列表导出',
  options: {
    url: '/customer/queryCustomerInfoForExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '用户数据批量导入数据验证',
  options: {
    url: '/customer/newCustomerImportCheckData',
    method: 'post'
  }
}, {
  desc: '用户信息批量导入',
  options: {
    url: '/customer/newCustomerImport',
    method: 'post'
  }
}, {
  desc: '查询用户版本',
  options: {
    url: '/customer/getPartnerexInfo',
    method: 'post'
  }
}, {
  desc: '查询用户商户',
  options: {
    url: '/customer/getOrgByPartner',
    method: 'post'
  }
}, {
  desc: '查询车险育成人推荐人',
  options: {
    url: '/customer/getCustomerByPartner',
    method: 'post'
  }
}, {
  desc: '收款人管理',
  options: {
    url: '/customer/queryPayeeCustomer',
    method: 'get'
  }
}, {
  desc: '收款人管理-启用、禁用人员',
  options: {
    url: '/customer/updatePayee',
    method: 'post'
  }
}, {
  desc: '查询用户附加权限',
  options: {
    url: '/permissionSet/queryCustomerAdditionalPermissionSet',
    method: 'post'
  }
}, {
  desc: '更新用户附加权限',
  options: {
    url: '/permissionSet/updateCustomerAuth',
    method: 'post'
  }
}, {
  desc: '附加角色列表查询接口',
  options: {
    url: '/customer/queryAdditionalRole',
    method: 'post'
  }
}, {
  desc: '附加角色保存',
  options: {
    url: '/customer/saveOrUpdateAdditionalRole',
    method: 'post'
  }
}, {
  desc: '切换组织角色',
  options: {
    url: '/customer/switchAdditionalRole',
    method: 'post'
  }
}]
export default policy



// WEBPACK FOOTER //
// ./src/api/people.js